/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I sort while ignoring capitalization?`)
};

const es_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo ordenar ignorando las mayúsculas?`)
};

const de_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich sortieren, ohne auf Groß-/Kleinschreibung zu achten?`)
};

const nl_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik sorteren terwijl ik kapitalisatie negeer?`)
};

const fr_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je trier en ignorant la capitalisation ?`)
};

const it_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso ordinare ignorando le maiuscole?`)
};

const pt_br2_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso ordenar ignorando maiúsculas?`)
};

const pt_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso classificar enquanto ignoro maiúsculas/minúsculas?`)
};

const ja_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字を無視してソートできますか?`)
};

const zh_ls_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以在排序时忽略大小写吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq4_q", locale)
	if (locale === "en") return en_ls_faq4_q(inputs)
	if (locale === "es") return es_ls_faq4_q(inputs)
	if (locale === "de") return de_ls_faq4_q(inputs)
	if (locale === "nl") return nl_ls_faq4_q(inputs)
	if (locale === "fr") return fr_ls_faq4_q(inputs)
	if (locale === "it") return it_ls_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq4_q(inputs)
	if (locale === "pt") return pt_ls_faq4_q(inputs)
	if (locale === "ja") return ja_ls_faq4_q(inputs)
	return zh_ls_faq4_q(inputs)
};